import { Component, OnInit } from '@angular/core';
import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { ModalDefinition } from '../../../services/overlay.service';
import { Project } from '../../../interfaces/project';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';
import { Subscription } from 'rxjs';
import { AbstractListComponent } from '../../shared/abstract-list.component';
import { AuthenticationService } from '../../../services/authentication.service';
import { ProjectService } from 'app/services/project.service';

@Component({
	selector: 'project-stats-list',
	templateUrl: './project-stats-list.component.html',
	styleUrls: ['./project-stats-list.component.scss'],
	providers: [BbTableService]
})

export class ProjectStatsListComponent extends AbstractListComponent implements OnInit {
	rows: TableRow[] = [];
	getRowsSubscription: Subscription;
	haveUserData = false;
	filterConfig: BbFilterConfiguration;
	deleteRight = false;

	constructor(protected bbTableService: BbTableService,
		protected authenticationService: AuthenticationService,
		private projectService: ProjectService) {
		super(bbTableService);

		this.authenticationService.hasPermission('delete').subscribe(hasRight => this.deleteRight = hasRight);

		this.listConfiguration = {
			name: 'project',
			basePath: '/analytics/project',
			activePath: '/analytics/projects'
		};

		this.filterConfig = {
			search: true,
			filters: this.projectService.getFilterConfigOptions(),
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('PUBLISHED'),
				value: 'published',
				filterSet: [{
					filters: [{
						type: 'project',
						field: 'status',
						operator: 'is',
						value: 'published'
					}]
				}],
			},
			{
				label: this.translate.instant('DRAFT'),
				value: 'draft',
				filterSet: [{
					filters: [{
						type: 'project',
						field: 'status',
						operator: 'is',
						value: 'draft'
					}]
				}],
			}]
		};
	}

	ngOnInit() {
		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();
	}

	redirectToProject(projectId: string) {
		this.router.navigate(['/analytics/project', projectId]);
	}

	showPreview(project: Project) {
		this.sapiService.get('commonclip', project.mainMediaClipId).subscribe((clip: Mediaclip) => {

			const modal: ModalDefinition = {
				icon: 'paper-plane',
				title: project.sourceid,
				component: {
					name: 'embed-preview',
					inputs: {
						mediaclip: clip
					}
				}
			};

			this.overlayService.createModal(modal);
		});
	}
}
